import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import ServiceHero from '../../components/services/ServiceHero';
import ServiceContent from '../../components/services/ServiceContent';
import ServiceCTA from '../../components/services/ServiceCTA';

const StaffAugmentation = () => {
  const serviceData = {
    title: 'Staff Augmentation',
    subtitle: 'Elite engineering talent on demand',
    description: 'Scale your team with vetted senior engineers who integrate seamlessly into your workflow. Get the expertise you need, when you need it, without the overhead of permanent hires.',
    sections: [
      {
        heading: 'How Our Staff Augmentation Works',
        items: [
          {
            title: 'Rapid Matching',
            description: 'Share your requirements and we match you with pre-vetted engineers from our talent pool within 48 hours.',
            icon: 'Zap'
          },
          {
            title: 'Seamless Integration',
            description: 'Our engineers adapt to your processes, tools, and culture. They work as an extension of your team.',
            icon: 'Users'
          },
          {
            title: 'Flexible Engagement',
            description: 'Scale up or down based on project needs. No long-term commitments, just talent when you need it.',
            icon: 'RefreshCw'
          },
          {
            title: 'Quality Assurance',
            description: 'All engineers are senior-level with proven track records. We handle vetting, so you get reliable talent.',
            icon: 'Shield'
          }
        ]
      }
    ],
    capabilities: [
      'Senior Full-Stack Developers',
      'Frontend Specialists (React, Vue, Angular)',
      'Backend Engineers (Node.js, Python, Java)',
      'Mobile Developers (iOS, Android, React Native)',
      'DevOps & Cloud Engineers',
      'AI/ML Engineers',
      'UI/UX Designers',
      'Product Managers',
      'QA & Test Engineers'
    ],
    technologies: ['React', 'Node.js', 'Python', 'Java', 'AWS', 'Azure', 'GCP', 'React Native', 'TypeScript']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Staff Augmentation & Engineering Teams"
        description="Scale your team with vetted senior engineers. Rapid matching, flexible engagement models, and seamless integration into your existing workflow."
        path="/services/staff-augmentation"
      />
      <Header />
      <ServiceHero data={serviceData} />
      <ServiceContent data={serviceData} />
      <ServiceCTA service="Staff Augmentation" />
      <Footer />
    </div>
  );
};

export default StaffAugmentation;
